/* Jaambu Life — theme behaviour
   No dependencies. Every module is optional and fails quietly if its markup
   is absent, so sections can be added or removed in the theme editor freely. */

(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------------------------------------------------------------- toast */

  var toastEl = document.getElementById('Toast');
  var toastTimer;

  function toast(message) {
    if (!toastEl) return;
    toastEl.textContent = message;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('is-visible');
    }, 2600);
  }

  function money(cents) {
    var f = (cents / 100).toFixed(2);
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active === 'USD' ? '$' : '') + f;
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ------------------------------------------------------------ cart drawer */

  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-drawer-overlay]');
  var lastFocus = null;

  function setCartCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = '(' + n + ')';
    });
    var badge = drawer && drawer.querySelector('[data-drawer-count]');
    if (badge) badge.textContent = n;
  }

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    overlay.hidden = false;
    /* next frame so the transition has a start value to animate from */
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
    });
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var close = drawer.querySelector('[data-drawer-close]');
    if (close) close.focus();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(function () {
      drawer.hidden = true;
      overlay.hidden = true;
    }, 300);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* Variant -> bundled pack shot, emitted by the drawer snippet. */
  var packMap = (function () {
    var el = document.querySelector('[data-pack-map]');
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  })();

  /* What a line would have cost without any deal: the higher of Shopify's
     pre-discount line price and the subscription plan's compare-at price.
     Mirrors the Liquid in cart-drawer so first paint and redraws agree. */
  /* Kaching rounds prices to .99, which takes a cent off a full-price pack.
     Differences under 50 cents are not shown as a deal or a saving. */
  var TRIVIAL = 50;

  function lineWas(item) {
    var was = item.original_line_price || 0;
    var spa = item.selling_plan_allocation;
    if (spa && spa.compare_at_price > spa.price) {
      was = Math.max(was, spa.compare_at_price * item.quantity);
    }
    return was;
  }

  function totalSaved(cart) {
    var was = (cart.items || []).reduce(function (sum, item) { return sum + lineWas(item); }, 0);
    var saved = was - cart.total_price;
    return saved >= TRIVIAL ? saved : 0;
  }

  function renderDrawer(cart) {
    if (!drawer) return;
    var body = drawer.querySelector('[data-drawer-body]');
    var foot = drawer.querySelector('[data-drawer-foot]');
    var total = drawer.querySelector('[data-drawer-total]');
    var wasEl = drawer.querySelector('[data-drawer-was]');
    var saveEl = drawer.querySelector('[data-drawer-savings]');
    var promos = drawer.querySelector('[data-drawer-promos]');

    setCartCount(cart.item_count);
    syncCrossSell(cart);
    syncShipping(cart);
    syncPromos(cart);
    syncCartSub(cart);
    if (promos) promos.hidden = !cart.items.length;

    if (!cart.items.length) {
      body.innerHTML =
        '<div class="drawer__empty">' +
        '<p class="lede">Your cart is empty.</p>' +
        '<button type="button" class="btn" data-drawer-close>Continue shopping</button>' +
        '</div>';
      foot.hidden = true;
      return;
    }

    foot.hidden = false;
    if (total) total.textContent = money(cart.total_price);

    /* Savings = everything the shopper would have paid without deals, minus
       what they pay now — bundle, subscription and code discounts together. */
    var wasTotal = cart.items.reduce(function (sum, item) { return sum + lineWas(item); }, 0);
    var saved = wasTotal - cart.total_price;
    if (wasEl) {
      wasEl.hidden = saved < TRIVIAL;
      wasEl.textContent = money(wasTotal);
    }
    if (saveEl) {
      saveEl.hidden = saved < TRIVIAL;
      var v = saveEl.querySelector('[data-drawer-savings-val]');
      if (v) v.textContent = money(saved);
    }

    body.innerHTML = cart.items
      .map(function (item) {
        /* "Jaambu Focus (Electrolytes & Endurance) – Mixed Berries" becomes
           "Focus · Mixed Berries", matching the product-name snippet, so each
           line stays one or two rows tall on a phone. The variant title only
           repeats the flavour then, so it is dropped. */
        var short = String(item.product_title || '')
          .replace(/\s*\([^)]*\)/, '')
          .replace(/^Jaambu\s+/i, '')
          .replace(/\s+[–-]\s+/, ' · ');
        var named = short !== item.product_title;
        var variant = !named && item.variant_title && item.variant_title.indexOf('Default') === -1 ? item.variant_title : '';
        var plan = item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.name : '';
        var meta = [variant, plan].filter(Boolean).join(' · ');
        var src = packMap[String(item.variant_id)] || item.image;
        var img = src
          ? '<img src="' + escapeHtml(src) + '" alt="" width="80" height="80" loading="lazy">'
          : '<span></span>';
        var was = lineWas(item);
        var deals = (item.line_level_discount_allocations || [])
          .map(function (a) { return a.amount >= TRIVIAL && a.discount_application && a.discount_application.title; })
          .filter(Boolean)
          .map(function (t) { return '<span class="drawer-item__deal">' + escapeHtml(t) + '</span>'; })
          .join('');
        /* Per-line subscription switch, for lines whose product has a plan. */
        var linePlan = planFor(item);
        var sub = !linePlan
          ? ''
          : item.selling_plan_allocation
            ? '<button type="button" class="drawer-item__sub drawer-item__sub--off" data-line-sub="0">Switch to one-time purchase</button>'
            : '<button type="button" class="drawer-item__sub" data-line-sub="1" data-plan="' + escapeHtml(linePlan.plan) + '">' +
              'Upgrade to Subscription &amp; Save ' + escapeHtml(linePlan.pct) + '%</button>';

        return (
          '<div class="drawer-item" data-key="' + escapeHtml(item.key) + '">' +
          img +
          '<div class="drawer-item__info">' +
          '<div class="drawer-item__title">' + escapeHtml(short) + '</div>' +
          (meta ? '<div class="drawer-item__meta">' + escapeHtml(meta) + '</div>' : '') +
          deals +
          '<div class="qty">' +
          '<button type="button" class="qty__btn" data-qty-down aria-label="Decrease quantity">−</button>' +
          '<span class="qty__n" data-qty>' + item.quantity + '</span>' +
          '<button type="button" class="qty__btn" data-qty-up aria-label="Increase quantity">+</button>' +
          '</div></div>' +
          '<div class="drawer-item__right">' +
          '<div class="drawer-item__price">' +
          (was - item.final_line_price >= TRIVIAL ? '<s>' + money(was) + '</s>' : '') +
          '<span>' + money(item.final_line_price) + '</span></div>' +
          '<button type="button" class="drawer-item__remove" data-remove>Remove</button>' +
          '</div>' + sub + '</div>'
        );
      })
      .join('');
  }

  /* Hides any cross-sell card whose variant is already in the cart, and the
     whole rail when nothing is left to suggest. */
  function syncCrossSell(cart) {
    var rail = document.querySelector('[data-xsell]');
    if (!rail) return;
    var inCart = (cart.items || []).map(function (i) { return String(i.variant_id); });
    var visible = 0;
    /* A cart that already holds subscription lines gets subscription
       suggestions too, so one upsell does not split the order into a
       subscription plus a stray one-time pack. */
    var subCart = (cart.items || []).some(function (i) { return !!i.selling_plan_allocation; });
    rail.querySelectorAll('[data-xsell-card]').forEach(function (card) {
      var hide = inCart.indexOf(String(card.dataset.variant)) !== -1;
      card.hidden = hide;
      if (!hide) visible++;

      var asSub = subCart && card.dataset.plan && Number(card.dataset.subPct) > 0;
      card.dataset.subscribe = asSub ? '1' : '';
      var price = card.querySelector('[data-xsell-price]');
      var cents = Number(card.dataset.cents);
      if (price && cents) {
        /* Off a subscription, the single-pack discount applies, so the card
           quotes the same figure as the shelf rather than the list price
           Shopify stores. Subscribing supersedes it and shows its own. */
        var introPct = Number(card.dataset.introPct) || 0;
        if (asSub) {
          price.innerHTML = '<s>' + money(cents) + '</s> ' +
            money(Math.round(cents * (1 - Number(card.dataset.subPct) / 100))) + ' · subscribe';
        } else if (introPct > 0) {
          price.innerHTML = money(Math.round(cents * (1 - introPct / 100))) +
            ' <s>' + money(cents) + '</s>';
        } else {
          price.textContent = money(cents);
        }
      }
    });
    rail.hidden = visible === 0 || !cart.item_count;
  }

  /* Free-shipping progress, counted in packs. Copy mirrors the
     free-shipping-bar snippet's first paint. */
  function syncShipping(cart) {
    document.querySelectorAll('[data-ship]').forEach(function (bar) {
      var goal = Number(bar.dataset.goal) || 2;
      var n = cart.item_count || 0;
      var left = Math.max(0, goal - n);
      var msg = bar.querySelector('[data-ship-msg]');
      var fill = bar.querySelector('[data-ship-fill]');
      var track = bar.querySelector('[data-ship-track]');

      bar.classList.toggle('is-done', left === 0);
      if (fill) fill.style.width = Math.min(100, (n / goal) * 100) + '%';
      if (track) track.setAttribute('aria-valuenow', String(Math.min(n, goal)));
      if (msg) {
        msg.innerHTML = left === 0
          ? 'You’ve unlocked <b>free shipping</b>'
          : 'Add <b>' + left + ' more ' + (left === 1 ? 'pack' : 'packs') + '</b> for free shipping';
      }
    });
  }

  /* ------------------------------------------------ cart-wide subscribe */

  /* Variant -> { plan, pct }, emitted by the drawer snippet. */
  var planMap = (function () {
    var el = document.querySelector('[data-plan-map]');
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  })();

  function planFor(item) {
    return planMap[String(item.variant_id)];
  }

  function syncCartSub(cart) {
    var wrap = document.querySelector('[data-cart-sub-wrap]');
    if (!wrap) return;
    var eligible = (cart.items || []).filter(planFor);
    wrap.hidden = !eligible.length;
    if (!eligible.length) return;
    var box = wrap.querySelector('[data-cart-sub]');
    var pct = wrap.querySelector('[data-cart-sub-pct]');
    if (box) box.checked = eligible.every(function (i) { return !!i.selling_plan_allocation; });
    if (pct) pct.textContent = planFor(eligible[0]).pct + '%';
  }

  /* Moves lines one at a time, re-reading the cart after each change: a line
     that switches plan gets a new key and can merge with a matching line, so
     positions are only trustworthy for one request. */
  function setCartSubscription(on) {
    if (!drawer) return;
    drawer.classList.add('is-busy');
    var guard = 0;

    function step(cart) {
      var idx = -1;
      (cart.items || []).some(function (item, i) {
        if (planFor(item) && !!item.selling_plan_allocation !== on) { idx = i; return true; }
        return false;
      });
      if (idx === -1 || guard++ > 20) return cart;
      var item = cart.items[idx];
      return fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: idx + 1, quantity: item.quantity, selling_plan: on ? planFor(item).plan : null })
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) throw new Error(data.description || data.message || 'Could not update the cart.');
            return data;
          });
        })
        .then(step);
    }

    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(step)
      .then(function (cart) {
        renderDrawer(cart);
        toast(on ? 'Subscription added — delivered every month' : 'Switched to one-time purchase');
      })
      .catch(function (err) {
        toast(err.message || 'Could not update the cart.');
        return refreshCart(false);
      })
      .then(function () { drawer.classList.remove('is-busy'); });
  }

  document.addEventListener('change', function (event) {
    var box = event.target.closest && event.target.closest('[data-cart-sub]');
    if (box) setCartSubscription(box.checked);
  });

  /* Moves a single line onto its plan, or back to one-time. */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-line-sub]');
    if (!btn || !drawer) return;
    var row = btn.closest('.drawer-item');
    var qty = row && row.querySelector('[data-qty]');
    if (!row || !qty) return;
    var on = btn.dataset.lineSub === '1';
    drawer.classList.add('is-busy');
    fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: row.dataset.key,
        quantity: Number(qty.textContent),
        selling_plan: on ? Number(btn.dataset.plan) : null
      })
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data.description || data.message || 'Could not update the cart.');
          return data;
        });
      })
      .then(function (cart) {
        renderDrawer(cart);
        toast(on ? 'Subscription added — delivered every month' : 'Switched to one-time purchase');
      })
      .catch(function (err) {
        toast(err.message || 'Could not update the cart.');
        return refreshCart(false);
      })
      .then(function () { drawer.classList.remove('is-busy'); });
  });

  /* ------------------------------------------------------- promo codes */

  /* Codes Shopify accepted for this cart, upper-cased for comparison. */
  function appliedCodes(cart) {
    return (cart.discount_codes || [])
      .filter(function (d) { return d.applicable; })
      .map(function (d) { return String(d.code).toUpperCase(); });
  }

  function syncPromos(cart) {
    var applied = appliedCodes(cart);
    document.querySelectorAll('[data-promo]').forEach(function (row) {
      var on = applied.indexOf(row.dataset.promo.toUpperCase()) !== -1;
      row.classList.toggle('is-applied', on);
      var btn = row.querySelector('[data-promo-apply]');
      if (btn) {
        btn.textContent = on ? 'Remove' : 'Apply';
        btn.setAttribute('aria-label', (on ? 'Remove code ' : 'Apply code ') + row.dataset.promo);
      }
    });

  }

  function updateDiscounts(codes) {
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    }).then(function (r) { return r.json(); });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-promo-apply]');
    if (!btn) return;
    var row = btn.closest('[data-promo]');
    var code = row.dataset.promo.toUpperCase();
    var onCartPage = !btn.closest('[data-cart-drawer]');
    btn.setAttribute('aria-disabled', 'true');

    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var before = appliedCodes(cart);
        var removing = before.indexOf(code) !== -1;
        var next = removing
          ? before.filter(function (c) { return c !== code; })
          : before.concat(code);

        return updateDiscounts(next).then(function (updated) {
          if (removing) {
            toast(code + ' removed');
            return updated;
          }
          if (appliedCodes(updated).indexOf(code) !== -1) {
            toast(code + ' applied — you’re now saving ' + money(totalSaved(updated)));
            return updated;
          }
          /* Shopify kept the code but marked it not applicable: put the
             cart back as it was rather than leave a dead code on it. */
          return updateDiscounts(before).then(function (reverted) {
            toast(code + ' can’t be combined with the offers already in your cart.');
            return reverted;
          });
        });
      })
      .then(function (cart) {
        if (onCartPage) { window.location.reload(); return; }
        renderDrawer(cart);
      })
      .catch(function () { toast('Could not apply ' + code + '.'); })
      .then(function () { btn.removeAttribute('aria-disabled'); });
  });

  /* Kaching adds bundles with its own fetch to /cart/add.js?kaching_bundles.
     When it is set to stay on the page rather than jump to checkout, open
     the drawer so the shopper sees the cart, shipping progress and offers. */
  (function () {
    if (!window.fetch) return;
    var nativeFetch = window.fetch;
    var wrapped = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = nativeFetch.apply(this, arguments);
      if (/\/cart\/add/.test(url) && /kaching/i.test(url)) {
        p.then(function (res) {
          if (res.ok) setTimeout(function () { refreshCart(true); }, 150);
        }).catch(function () {});
      }
      return p;
    };
    /* Keep any markers another script (Kaching) set on its own wrapper. */
    Object.keys(nativeFetch).forEach(function (k) { wrapped[k] = nativeFetch[k]; });
    window.fetch = wrapped;
  })();

  /* Cart page: mark codes already on the cart. */
  if (document.querySelector('.cart-promos [data-promo]')) {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(syncPromos)
      .catch(function () {});
  }

  document.addEventListener('click', function (event) {
    var add = event.target.closest('[data-xsell-add]');
    if (!add) return;
    var card = add.closest('[data-xsell-card]');
    var plan = card && card.dataset.subscribe === '1' ? card.dataset.plan : '';
    addToCart(add.dataset.variant, plan, add.dataset.label || 'Item', 1);
  });

  function refreshCart(open) {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderDrawer(cart);
        if (open) openDrawer();
        return cart;
      });
  }

  function changeLine(key, quantity) {
    if (!drawer) return;
    drawer.classList.add('is-busy');
    fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(renderDrawer)
      .catch(function () { toast('Could not update the cart.'); })
      .then(function () { drawer.classList.remove('is-busy'); });
  }

  if (drawer) {
    document.addEventListener('click', function (event) {
      var open = event.target.closest('[data-drawer-open]');
      if (open) {
        event.preventDefault();
        refreshCart(true);
        return;
      }
      if (event.target.closest('[data-drawer-close]')) {
        closeDrawer();
        return;
      }

      var line = event.target.closest('.drawer-item');
      if (!line) return;
      var key = line.dataset.key;
      var qtyEl = line.querySelector('[data-qty]');
      var qty = qtyEl ? Number(qtyEl.textContent) : 1;

      if (event.target.closest('[data-remove]')) changeLine(key, 0);
      else if (event.target.closest('[data-qty-up]')) changeLine(key, qty + 1);
      else if (event.target.closest('[data-qty-down]')) changeLine(key, Math.max(0, qty - 1));
    });

    if (overlay) overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
  }

  /* Opens and closes the full text of a long review. */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-review-toggle]');
    if (!btn) return;
    var body = document.getElementById(btn.getAttribute('aria-controls'));
    if (!body) return;
    var open = body.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', String(open));
    btn.textContent = open ? 'Read less' : 'Read more';
  });

  /* ------------------------------------------------------- hero carousel */

  /* Cross-fades the hero photos on a timer, with arrows, dots and swipe.
     Using any control restarts the timer; it pauses while the pointer is
     over the photo or the tab is hidden. */
  document.querySelectorAll('[data-hero-carousel]').forEach(function (box) {
    var slides = Array.prototype.slice.call(box.children).filter(function (el) { return el.tagName === 'IMG'; });
    if (slides.length < 2) return;
    var dotsEl = box.querySelector('[data-hero-dots]');
    var interval = Number(box.dataset.interval) || 7000;
    var index = 0;
    var timer = null;

    var dots = slides.map(function (img, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'hero__dot';
      b.setAttribute('aria-label', 'Show photo ' + (i + 1) + ' of ' + slides.length);
      b.addEventListener('click', function () { go(i); restart(); });
      dotsEl.appendChild(b);
      return b;
    });

    function load(img) { if (img.loading === 'lazy') img.loading = 'eager'; }

    function go(i) {
      index = (i + slides.length) % slides.length;
      load(slides[index]);
      slides.forEach(function (img, n) { img.classList.toggle('is-active', n === index); });
      dots.forEach(function (d, n) { d.setAttribute('aria-current', n === index ? 'true' : 'false'); });
      /* Fetch the next photo early so it is ready before its turn. */
      load(slides[(index + 1) % slides.length]);
    }
    function stop() { clearInterval(timer); timer = null; }
    function restart() { stop(); timer = setInterval(function () { go(index + 1); }, interval); }

    box.querySelector('[data-hero-prev]').addEventListener('click', function () { go(index - 1); restart(); });
    box.querySelector('[data-hero-next]').addEventListener('click', function () { go(index + 1); restart(); });
    box.addEventListener('mouseenter', stop);
    box.addEventListener('mouseleave', restart);
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else restart(); });

    var startX = null;
    box.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      startX = null;
      if (Math.abs(dx) > 40) { go(index + (dx < 0 ? 1 : -1)); restart(); }
    });

    go(0);
    box.classList.add('is-ready');
    restart();
  });

  /* --------------------------------------------------- Fera reviews rail */

  /* Draws Fera's reviews as one scrolling row of cards. Fera's script loads
     late and holds the store's public key, so this waits for it, then reads
     the same public reviews feed Fera's own widgets use. */
  (function () {
    var rail = document.querySelector('[data-fera-rail]');
    if (!rail) return;
    var track = rail.querySelector('[data-fera-rail-track]');
    var tries = 0;

    function card(r, i) {
      var stars = '';
      for (var s = 1; s <= 5; s++) stars += s <= Math.round(r.rating) ? '★' : '☆';
      var body = String(r.body || '');
      var long = body.length > 170;
      var id = 'FeraReview-' + i;
      var who = r.customer && r.customer.display_name ? r.customer.display_name : 'Verified buyer';
      var product = r.product && r.product.handle
        ? '<a class="fera-card__product" href="' + root + 'products/' + escapeHtml(r.product.handle) + '">' +
          escapeHtml(String(r.product.name || '').replace(/&amp;/g, '&').replace(/\s*\([^)]*\)/, '').replace(/^Jaambu\s+/i, '').replace(/\s+[–-]\s+/, ' · ')) + '</a>'
        : '';
      var source = r.channel && r.channel.name ? ' · ' + escapeHtml(r.channel.name) + ' review' : '';

      return (
        '<article class="fera-card">' +
        '<span class="stars" aria-label="' + r.rating + ' out of 5">' + stars + '</span>' +
        (r.heading ? '<h3 class="fera-card__title">' + escapeHtml(r.heading) + '</h3>' : '') +
        '<p class="review__body' + (long ? ' review__body--clamp' : '') + '" id="' + id + '">' + escapeHtml(body) + '</p>' +
        (long ? '<button type="button" class="review__toggle" data-review-toggle aria-expanded="false" aria-controls="' + id + '">Read more</button>' : '') +
        '<div class="fera-card__meta"><b>' + escapeHtml(who) + '</b>' + source + product + '</div>' +
        '</article>'
      );
    }

    /* Customer videos and photos rendered by Liquid. They are lifted out,
       then put back alternating with the reviews: media, review, media... */
    var videos = Array.prototype.slice.call(track.querySelectorAll('[data-ugc]'));

    function draw(data) {
      var list = data.data || [];
      if (!list.length) return;
      videos.forEach(function (v) { v.remove(); });
      track.innerHTML = list.map(card).join('');
      var reviews = Array.prototype.slice.call(track.children);
      videos.forEach(function (v, i) {
        var before = reviews[i];
        if (before) track.insertBefore(v, before);
        else track.appendChild(v);
      });
      watchVideos();
      var rating = data.rating || {};
      var total = rating.count || (data.meta && data.meta.total_count) || list.length;
      var avg = rating.average || list.reduce(function (sum, r) { return sum + r.rating; }, 0) / list.length;
      rail.querySelector('[data-fera-rail-avg]').textContent = Number(avg).toFixed(1);
      rail.querySelector('[data-fera-rail-count]').textContent = total + (total === 1 ? ' review' : ' reviews');
      rail.hidden = false;
    }

    /* Videos play muted while on screen and pause off it, so a row of clips
       never plays all at once or downloads before it is seen. */
    function watchVideos() {
      if (!videos.length || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting && e.intersectionRatio > 0.6) {
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
          }
        });
      }, { threshold: [0, 0.6, 1] });
      videos.forEach(function (card) {
        var v = card.querySelector('video');
        if (v) io.observe(v);
      });
    }

    /* Sound is off until asked for, and only one clip is heard at a time. */
    track.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-ugc-sound]');
      if (!btn) return;
      var video = btn.closest('[data-ugc]').querySelector('video');
      var on = video.muted;
      videos.forEach(function (card) {
        var v = card.querySelector('video');
        var b = card.querySelector('[data-ugc-sound]');
        if (!v || !b) return;
        v.muted = true;
        b.setAttribute('aria-pressed', 'false');
        b.setAttribute('aria-label', 'Turn sound on');
      });
      video.muted = !on;
      if (on) {
        btn.setAttribute('aria-pressed', 'true');
        btn.setAttribute('aria-label', 'Turn sound off');
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      }
    });

    function load() {
      var cfg = window.fera && window.fera.config;
      var key = cfg && (cfg.apiKey || cfg.api_key);
      if (!key) {
        if (tries++ < 60) setTimeout(load, 300);
        return;
      }
      var base = cfg.baseApiCdnUrl || 'https://cdn.fera.ai/api/v3/public';
      fetch(base + '/reviews.json?api_key=' + encodeURIComponent(key) + '&page_size=24&sort_by=created_at:desc&include_aggregate_rating=true')
        .then(function (r) { return r.json(); })
        .then(draw)
        .catch(function () {});
    }
    load();

    function slide(dir) {
      track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' });
    }
    rail.querySelector('[data-fera-rail-prev]').addEventListener('click', function () { slide(-1); });
    rail.querySelector('[data-fera-rail-next]').addEventListener('click', function () { slide(1); });
    rail.querySelector('[data-fera-rail-write]').addEventListener('click', function () {
      if (window.fera && window.fera.showContentSubmitter) window.fera.showContentSubmitter();
    });
  })();

  /* ----------------------------------------------------------------- cart */

  /* Adds one or more variants in a single request. Resolves to false when the
     caller has no variant id yet — the catalogue may not be connected during
     design review. `variants` is an id or an array of ids. */
  function addToCart(variants, sellingPlanId, label, quantity) {
    var ids = (Array.isArray(variants) ? variants : [variants]).filter(Boolean);

    if (!ids.length) {
      toast(label + ' is not connected to a product yet.');
      return Promise.resolve(false);
    }

    var qty = Number(quantity) > 0 ? Number(quantity) : 1;

    var body = {
      items: ids.map(function (id) {
        var line = { id: Number(id), quantity: qty };
        if (sellingPlanId) line.selling_plan = Number(sellingPlanId);
        return line;
      })
    };

    return postCart({
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }, label);
  }

  /* POSTs to /cart/add.js, then refreshes and opens the drawer. Shared by the
     JSON adds above and the product-page form, which sends FormData so any
     fields a bundle app injected travel with it. */
  function postCart(init, label) {
    return fetch(root + 'cart/add.js', init)
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
          return data;
        });
      })
      .then(function () {
        return refreshCart(true).then(function () {
          toast(label + ' added to cart');
          return true;
        });
      })
      .catch(function (err) {
        toast(err.message);
        return false;
      });
  }

  /* --------------------------------------------------------------- swipe */

  /* Horizontal drag/swipe on a stage. Ignores mostly-vertical gestures so the
     page still scrolls normally under a finger. */
  function attachSwipe(el, onNext, onPrev) {
    if (!el) return;
    var x0 = null, y0 = null, locked = false;

    var start = function (e) {
      var t = e.touches ? e.touches[0] : e;
      x0 = t.clientX; y0 = t.clientY; locked = false;
    };
    var move = function (e) {
      if (x0 === null) return;
      var t = e.touches ? e.touches[0] : e;
      var dx = t.clientX - x0, dy = t.clientY - y0;
      if (!locked && Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) locked = true;
      if (locked && e.cancelable) e.preventDefault();
    };
    var end = function (e) {
      if (x0 === null) return;
      var t = (e.changedTouches ? e.changedTouches[0] : e);
      var dx = t.clientX - x0, dy = t.clientY - y0;
      x0 = y0 = null;
      if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy)) return;
      if (dx < 0) onNext(); else onPrev();
    };

    el.addEventListener('touchstart', start, { passive: true });
    el.addEventListener('touchmove', move, { passive: false });
    el.addEventListener('touchend', end);

    /* Mouse drag, so the same gesture works on a trackpad. */
    el.addEventListener('mousedown', function (e) { start(e); e.preventDefault(); });
    window.addEventListener('mouseup', function (e) { if (x0 !== null) end(e); });

    el.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { onNext(); e.preventDefault(); }
      if (e.key === 'ArrowLeft') { onPrev(); e.preventDefault(); }
    });
    el.tabIndex = 0;
  }

  /* ------------------------------------------------------ science graph --- */

  /* Draws each curve on when the chart scrolls into view. The animation class
     is added by script, so with JS off the chart simply renders complete. */
  document.querySelectorAll('[data-graph]').forEach(function (fig) {
    var lines = fig.querySelectorAll('.graph__line');
    if (!lines.length) return;

    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) return;

    lines.forEach(function (line, i) {
      var len = 0;
      try { len = line.getTotalLength(); } catch (e) { return; }
      line.style.setProperty('--len', Math.ceil(len));
      line.style.setProperty('--dur', 1300 + i * 260 + 'ms');
      line.style.setProperty('--delay', i * 200 + 'ms');
    });

    fig.querySelectorAll('.graph__callout').forEach(function (c, i) {
      c.style.setProperty('--delay', 900 + i * 220 + 'ms');
    });
    fig.querySelectorAll('.graph__legend .graph__leg').forEach(function (c, i) {
      c.style.setProperty('--delay', i * 120 + 'ms');
    });
    fig.querySelectorAll('.graph__notes li').forEach(function (c, i) {
      c.style.setProperty('--delay', 1200 + i * 160 + 'ms');
    });

    fig.classList.add('graph--animate');

    if (!('IntersectionObserver' in window)) {
      fig.classList.add('is-drawn');
      return;
    }
    new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        fig.classList.add('is-drawn');
        obs.disconnect();
      });
    }, { threshold: 0.25 }).observe(fig);
  });

  /* ------------------------------------------------- floating Buy now ---- */

  /* Shown on every page. On pages with a picker the mobile buy bar takes over
     once the real Add button scrolls away, so the pill yields to it rather
     than stacking two competing calls to action. */
  (function () {
    var btn = document.querySelector('[data-buynow]');
    if (!btn) return;

    var bar = document.querySelector('[data-buybar]');
    btn.hidden = false;

    /* The button exists to take people to the picker, so it steps aside
       while any picker (home #formulas, or a product page's selector) is on
       screen. */
    var pickers = document.querySelectorAll('[data-selector]');
    var onPicker = 0;
    if (pickers.length && 'IntersectionObserver' in window) {
      var seen = new Set();
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) seen.add(e.target); else seen.delete(e.target);
        });
        onPicker = seen.size;
        show();
      }, { threshold: 0.15 });
      pickers.forEach(function (p) { io.observe(p.closest('section') || p); });
    }

    var show = function () {
      var barUp = bar && bar.classList.contains('is-visible') &&
                  getComputedStyle(bar).display !== 'none';
      btn.classList.toggle('is-visible', window.scrollY > 520 && !barUp && !onPicker);
    };

    show();
    window.addEventListener('scroll', show, { passive: true });
    window.addEventListener('resize', show);

    /* The buy bar is toggled by an IntersectionObserver, not by scroll, so
       watch its class directly rather than guessing from scroll position. */
    if (bar && 'MutationObserver' in window) {
      new MutationObserver(show).observe(bar, { attributes: true, attributeFilter: ['class'] });
    }
  })();

  /* --------------------------------------------------------------- header */

  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-stuck', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  var navToggle = document.querySelector('[data-nav-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (navToggle && mobileNav) {
    navToggle.addEventListener('click', function () {
      var open = navToggle.getAttribute('aria-expanded') === 'true';
      navToggle.setAttribute('aria-expanded', String(!open));
      mobileNav.classList.toggle('is-open', !open);
    });
  }

  /* --------------------------------------------------- reviews rail media */

  /* Customer media in the reviews rail.

     Liquid emits the media cards after the reviews, because the review cards
     come out of a generated snippet that cannot be interleaved server-side.
     They are lifted out here and dealt back through the row — media, some
     reviews, media — which is how the Fera rail has always shown them. That
     rail owns its own copies, so the two never compete for the same cards. */
  document.querySelectorAll('.reviews__rail').forEach(function (rail) {
    var media = Array.prototype.slice.call(rail.querySelectorAll('[data-ugc]'));
    if (!media.length) return;

    /* Clips lead, stills follow. Sort is stable, so within each group the
       order set in the theme editor is kept. */
    media.sort(function (a, b) {
      return (a.querySelector('video') ? 0 : 1) - (b.querySelector('video') ? 0 : 1);
    });

    media.forEach(function (m) { m.remove(); });
    var cards = Array.prototype.slice.call(rail.children);

    /* Strictly alternating from the front — media, review, media, review —
       the way the Fera rail deals them. Spreading them evenly over the whole
       row instead pushed the first clip twelve cards along, which in a rail
       that scrolls sideways means nobody ever sees one. */
    media.forEach(function (m, i) {
      var before = cards[i];
      if (before) rail.insertBefore(m, before);
      else rail.appendChild(m);
    });

    /* Muted autoplay while on screen, so a row of clips neither plays all at
       once nor downloads before it is scrolled to. */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && e.intersectionRatio > 0.6) {
            var p = e.target.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            e.target.pause();
          }
        });
      }, { threshold: [0, 0.6, 1] });
      media.forEach(function (m) {
        var v = m.querySelector('video');
        if (v) io.observe(v);
      });
    }

    /* Sound is off until asked for, and only one clip is heard at a time. */
    rail.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-ugc-sound]');
      if (!btn) return;
      var video = btn.closest('[data-ugc]').querySelector('video');
      if (!video) return;
      var turningOn = video.muted;
      media.forEach(function (m) {
        var v = m.querySelector('video');
        var b = m.querySelector('[data-ugc-sound]');
        if (!v || !b) return;
        v.muted = true;
        b.setAttribute('aria-pressed', 'false');
        b.setAttribute('aria-label', 'Turn sound on');
      });
      if (turningOn) {
        video.muted = false;
        btn.setAttribute('aria-pressed', 'true');
        btn.setAttribute('aria-label', 'Turn sound off');
        var play = video.play();
        if (play && play.catch) play.catch(function () {});
      }
    });
  });

  /* Mirrors snippets/star-rating.liquid: a grey five-star row with a gold one
     clipped over it, so a part-star score draws as a part star rather than
     rounding up. Returns null below a score of 1 so a product with no reviews
     shows nothing at all. */
  function buildStarRating(rating, count, opts) {
    opts = opts || {};
    var r = Number(rating) || 0;
    if (r <= 0) return null;

    var wrap = document.createElement(opts.href ? 'a' : 'span');
    if (opts.href) wrap.href = opts.href;
    wrap.className = 'star-rating' + (opts.size === 'sm' ? ' star-rating--sm' : '');

    if (opts.showScore) {
      var score = document.createElement('span');
      score.className = 'star-rating__score';
      score.textContent = r;
      wrap.appendChild(score);
    }

    var stars = document.createElement('span');
    stars.className = 'star-rating__stars';
    stars.setAttribute('role', 'img');
    stars.setAttribute('aria-label', r + ' out of 5 stars' + (count ? ', ' + count + ' reviews' : ''));

    var base = document.createElement('span');
    base.className = 'star-rating__base';
    base.setAttribute('aria-hidden', 'true');
    base.textContent = '★★★★★';
    stars.appendChild(base);

    var fill = document.createElement('span');
    fill.className = 'star-rating__fill';
    fill.setAttribute('aria-hidden', 'true');
    fill.textContent = '★★★★★';
    fill.style.width = (r * 20) + '%';
    stars.appendChild(fill);

    wrap.appendChild(stars);

    if (count) {
      var c = document.createElement('span');
      c.className = 'star-rating__count';
      c.textContent = opts.full
        ? count + ' review' + (count === 1 ? '' : 's')
        : '(' + count + ')';
      wrap.appendChild(c);
    }
    return wrap;
  }

  /* ----------------------------------------------------- formula selector */

  document.querySelectorAll('[data-selector]').forEach(function (el) {
    var dataEl = el.closest('section').querySelector('[data-selector-data]');
    if (!dataEl) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    if (!data.formulas || !data.formulas.length) return;

    var packEl = el.querySelector('[data-pack]');
    var shotEl = el.querySelector('[data-shot]');
    var chipEl = el.querySelector('[data-chip]');
    var nameEl = el.querySelector('[data-name]');
    var leadEl = el.querySelector('[data-lead]');
    var priceEl = el.querySelector('[data-price]');
    var thumbsEl = el.querySelector('[data-thumbs]');
    var flavoursEl = el.querySelector('[data-flavours]');
    var addBtn = el.querySelector('[data-add]');

    /* On a product page the selector carries one formula, opens on that
       product's flavour, and keeps the address bar on whichever flavour is
       showing so a refresh or share lands on the same SKU. */
    var pdp = el.hasAttribute('data-pdp');
    var titleEl = el.querySelector('[data-pdp-title]');
    var ratingEl = el.querySelector('[data-pdp-rating]');

    var state = { formula: 0, flavour: Number(el.dataset.flavour) || 0, slide: 0, buy: 'subscribe' };
    if (state.flavour >= data.formulas[0].flavours.length) state.flavour = 0;

    function current() { return data.formulas[state.formula]; }
    function currentFlavour() { return current().flavours[state.flavour]; }

    /* Slide 0 is always the selected flavour pack; 1..n are that formula's
       own PDP shots, so switching formula swaps the whole gallery. */
    function slides() {
      var f = currentFlavour();
      var head = { image: f.image, thumb: f.thumb || f.image, label: f.name };
      return [head].concat(current().gallery || []);
    }

    function renderStage() {
      var list = slides();
      if (state.slide >= list.length) state.slide = 0;
      var slide = list[state.slide];

      shotEl.hidden = false;
      shotEl.src = slide.image;
      shotEl.alt = current().name + ' — ' + slide.label;
      if (packEl) packEl.style.visibility = 'hidden';
    }

    function renderThumbs() {
      var list = slides();
      thumbsEl.innerHTML = '';
      list.forEach(function (slide, i) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'thumb';
        btn.setAttribute('aria-current', String(i === state.slide));
        btn.setAttribute('aria-label', 'View ' + slide.label);

        var img = document.createElement('img');
        img.src = slide.thumb || slide.image;
        img.alt = '';
        img.loading = 'lazy';
        img.decoding = 'async';
        img.width = 160;
        img.height = 160;
        btn.appendChild(img);

        var n = document.createElement('span');
        n.className = 'thumb__n';
        n.textContent = '0' + (i + 1);
        btn.appendChild(n);

        btn.addEventListener('click', function () {
          state.slide = i;
          renderStage();
          renderThumbs();
        });

        thumbsEl.appendChild(btn);
      });
    }

    function renderFlavours() {
      flavoursEl.innerHTML = '';
      current().flavours.forEach(function (flavour, i) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pill';
        btn.setAttribute('aria-pressed', String(i === state.flavour));

        var dot = document.createElement('i');
        dot.className = 'dot';
        dot.style.color = flavour.dot;
        btn.appendChild(dot);
        btn.appendChild(document.createTextNode(flavour.name));

        /* Each flavour is its own SKU with its own reviews, so the pill
           carries that flavour's score rather than the formula's. */
        var pillStars = buildStarRating(flavour.rating, flavour.reviews, { size: 'sm' });
        if (pillStars) btn.appendChild(pillStars);

        btn.addEventListener('click', function () {
          /* Each flavour is its own product, and bundle apps render per
             product, so on a product page a flavour is a real page load. */
          if (pdp && flavour.url && flavour.url !== window.location.pathname) {
            window.location.href = flavour.url;
            return;
          }
          state.flavour = i;
          state.slide = 0;
          renderAll();
        });

        flavoursEl.appendChild(btn);
      });
    }

    /* Nutrition panel, redrawn whenever the formula changes. */
    function renderFacts() {
      var host = el.querySelector('[data-facts]');
      if (!host) return;
      var f = current().facts || {};
      var rows = [
        ['Serving size', f.servingSize],
        ['Servings per container', f.servings],
        ['Net weight', f.netWeight],
        ['Suggested use', f.suggestedUse]
      ].filter(function (r) { return r[1]; });

      host.innerHTML = rows.map(function (r) {
        return '<dt>' + escapeHtml(r[0]) + '</dt><dd>' + escapeHtml(r[1]) + '</dd>';
      }).join('');

      var ing = el.querySelector('[data-facts-ingredients]');
      if (ing) {
        var list = (f.ingredients || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
        ing.innerHTML = list.length
          ? '<span class="facts__label">Ingredients</span><div class="chips">' +
            list.map(function (x) { return '<span class="chip">' + escapeHtml(x) + '</span>'; }).join('') + '</div>'
          : '';
      }

      var bg = el.querySelector('[data-facts-badges]');
      if (bg) {
        var badges = (f.badges || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
        bg.innerHTML = badges.map(function (x) {
          return '<span class="badge">' + escapeHtml(x) + '</span>';
        }).join('');
      }
    }

    /* Money strings come from Liquid already formatted; parse just the number
       so the per-day figure can be derived without re-implementing currency. */
    function priceNumber(s) {
      var n = parseFloat(String(s || '').replace(/[^0-9.]/g, ''));
      return isNaN(n) ? 0 : n;
    }

    function renderBuyPricing() {
      var f = currentFlavour();
      var unit = priceNumber(f.price);
      var sachets = Number(data.sachetsPerPack) > 0 ? Number(data.sachetsPerPack) : 15;
      var qty = subscribeQty();
      var sym = (f.price || '').replace(/[0-9.,\s]/g, '') || '$';

      /* An explicit subscription price wins over the calculated total, so the
         panel can show a plan rate that differs from qty x unit price. */
      var override = priceNumber(data.subscribePrice);
      var subTotal = override > 0 ? override : unit * qty;

      var set = function (sel, text) {
        var n = el.querySelector(sel);
        if (n) n.textContent = text;
      };
      if (!unit) {
        set('[data-sub-price]', ''); set('[data-one-price]', '');
        set('[data-sub-perday]', ''); set('[data-one-perday]', '');
        return;
      }
      set('[data-sub-price]', sym + subTotal.toFixed(2));
      set('[data-one-price]', sym + unit.toFixed(2));
      set('[data-sub-perday]', sym + (subTotal / (sachets * qty)).toFixed(2) + '/day');
      set('[data-one-perday]', sym + (unit / sachets).toFixed(2) + '/day');
    }

    function renderPrice() {
      if (!priceEl) return;
      var f = currentFlavour();
      if (!f.price || !f.variantId) {
        priceEl.hidden = true;
        return;
      }
      priceEl.hidden = false;

      /* Older markup held the price as bare text. Keep writing to that when
         the split spans are absent, so a page that has not picked up the new
         template still shows a price rather than nothing. */
      var nowEl = priceEl.querySelector('[data-price-now]');
      var wasEl = priceEl.querySelector('[data-price-was]');
      if (!nowEl) {
        priceEl.textContent = f.price;
        return;
      }

      nowEl.textContent = f.price;
      if (wasEl) {
        wasEl.textContent = f.compareAt || '';
        wasEl.hidden = !f.compareAt;
      }
    }

    function renderAll() {
      var f = current();
      el.dataset.formula = f.key;
      if (chipEl) chipEl.textContent = f.name;
      if (nameEl) nameEl.textContent = f.name;
      if (leadEl) leadEl.textContent = f.lead;

      if (pdp) {
        var fl = currentFlavour();
        if (titleEl) titleEl.textContent = f.name + ' · ' + fl.name;

        /* The panel rating belongs to the flavour on screen, so it is redrawn
           alongside the title when the pills switch in place. */
        if (ratingEl) {
          ratingEl.textContent = '';
          var panelStars = buildStarRating(fl.rating, fl.reviews, {
            showScore: true, full: true, href: '#reviews'
          });
          if (panelStars) ratingEl.appendChild(panelStars);
        }
        if (fl.url && window.history.replaceState && window.location.pathname !== fl.url) {
          window.history.replaceState(null, '', fl.url);
        }
      }

      /* Deliberately not gated on variant.available: these products oversell,
         so Liquid reports available:false while /cart/add.js accepts them.
         Shopify is the authority — a genuine rejection surfaces via the catch
         in addToCart rather than pre-emptively disabling the button here. */
      addBtn.textContent = 'Add ' + f.name + ' to cart';
      addBtn.removeAttribute('aria-disabled');

      renderFlavours();
      renderPrice();
      renderFacts();
      renderBuyPricing();
      renderStage();
      renderThumbs();
      syncPanes();
    }

    /* Home picker: one Kaching pane per flavour product. The selected
       flavour's pane is shown once Kaching has rendered a deal into it, and
       then it replaces step 3 and the main button; with no deal the theme's
       own purchase options stay. */
    var panes = [].slice.call(el.querySelectorAll('[data-kpane]'));

    function activePane() {
      return el.querySelector('[data-kpane="' + state.formula + '-' + state.flavour + '"]');
    }

    function paneHasDeal(p) {
      return !!(p && p.querySelector('kaching-bundles-block'));
    }

    function syncPanes() {
      if (!panes.length) return;
      var active = activePane();
      var on = paneHasDeal(active);
      panes.forEach(function (p) { p.hidden = !(on && p === active); });
      var step = el.querySelector('[data-buy-step]');
      if (step) step.hidden = on;
      if (addBtn) addBtn.style.display = on ? 'none' : '';
      el.classList.toggle('has-bundle-app', on);
    }

    if (panes.length && 'MutationObserver' in window) {
      var paneSync = 0;
      new MutationObserver(function () {
        cancelAnimationFrame(paneSync);
        paneSync = requestAnimationFrame(syncPanes);
      }).observe(el.querySelector('.kbundles') || el, { childList: true, subtree: true });
    }

    el.querySelectorAll('[data-choice]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.formula = Number(btn.dataset.choice);
        state.flavour = 0;
        state.slide = 0;
        el.querySelectorAll('[data-choice]').forEach(function (b) {
          b.setAttribute('aria-pressed', String(b === btn));
        });
        if (packEl) {
          packEl.classList.add('is-swapping');
          setTimeout(function () { packEl.classList.remove('is-swapping'); }, 180);
        }
        renderAll();
      });
    });

    el.querySelectorAll('[data-buy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.buy = btn.dataset.buy;
        el.querySelectorAll('[data-buy]').forEach(function (b) {
          var on = b === btn;
          b.setAttribute('aria-pressed', String(on));
          b.setAttribute('aria-checked', String(on));
        });
      });
    });

    /* A pack holds 15 sachets, so a 30-day subscription ships two packs
       rather than shipping a single pack every 15 days. */
    function subscribeQty() {
      return Number(data.subscribeQuantity) > 0 ? Number(data.subscribeQuantity) : 1;
    }

    function addCurrent() {
      var subscribing = state.buy === 'subscribe';
      var plan = subscribing ? data.sellingPlans.subscribe : '';
      var label = current().name + ' · ' + currentFlavour().name;
      return addToCart(currentFlavour().variantId, plan, label, subscribing ? subscribeQty() : 1);
    }

    /* Product page: a real product form. A bundle app (Kaching) injects its
       picker and its own fields into the page; while one is present it owns
       quantity and pricing, so the theme's purchase-option step is hidden and
       the form is sent exactly as the app left it. */
    var pdpForm = pdp && el.querySelector('[data-pdp-form]');
    var buyStep = el.querySelector('[data-buy-step]');
    var BUNDLE_SEL = 'kaching-bundles-block, kaching-bundle, [class*="kaching"], [id*="kaching"]';

    function bundleApp() {
      return !!el.querySelector(BUNDLE_SEL);
    }

    function syncBundleApp() {
      var on = bundleApp();
      el.classList.toggle('has-bundle-app', on);
      if (buyStep) buyStep.hidden = on;
    }

    if (pdpForm) {
      syncBundleApp();
      if ('MutationObserver' in window) {
        new MutationObserver(syncBundleApp).observe(el, { childList: true, subtree: true });
      }

      pdpForm.addEventListener('submit', function (event) {
        /* An app that handles the add itself cancels the event first. */
        if (event.defaultPrevented) return;
        event.preventDefault();

        var label = current().name + ' · ' + currentFlavour().name;
        if (!bundleApp()) {
          var subscribing = state.buy === 'subscribe';
          var qty = pdpForm.querySelector('[data-pdp-qty]');
          if (qty) qty.value = subscribing ? subscribeQty() : 1;
          var plan = subscribing ? data.sellingPlans.subscribe : '';
          var planInput = pdpForm.querySelector('input[name="selling_plan"]');
          if (plan && !planInput) {
            planInput = document.createElement('input');
            planInput.type = 'hidden';
            planInput.name = 'selling_plan';
            pdpForm.appendChild(planInput);
          }
          if (planInput) {
            if (plan) planInput.value = plan;
            else planInput.remove();
          }
        }

        addBtn.setAttribute('aria-disabled', 'true');
        postCart({
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(pdpForm)
        }, label).then(function () {
          addBtn.removeAttribute('aria-disabled');
        });
      });

      /* The floating bar submits the same form, so it carries app fields too. */
      addCurrent = function () {
        if (pdpForm.requestSubmit) pdpForm.requestSubmit();
        else pdpForm.dispatchEvent(new Event('submit', { cancelable: true }));
      };
    } else if (addBtn) {
      addBtn.addEventListener('click', addCurrent);

      /* With a Kaching pane showing, the floating bar submits that pane's
         form so the chosen bundle is what gets added. */
      var addJson = addCurrent;
      addCurrent = function () {
        var p = activePane();
        var f = paneHasDeal(p) && p.querySelector('[data-kform]');
        if (!f) return addJson();
        var b = f.querySelector('[type="submit"]');
        if (b) b.click();
        else if (f.requestSubmit) f.requestSubmit();
      };
    }

    /* ---- floating add-to-cart, mirrored from this selector ---- */
    var buybar = document.querySelector('[data-buybar]');
    if (buybar && addBtn) {
      var barName = buybar.querySelector('[data-buybar-name]');
      var barMeta = buybar.querySelector('[data-buybar-meta]');
      var barAdd = buybar.querySelector('[data-buybar-add]');

      var syncBar = function () {
        var f = current(), fl = currentFlavour();
        barName.textContent = f.name + ' · ' + fl.name;
        barMeta.textContent = [fl.price, state.buy === 'subscribe' ? 'Subscribe & Save' : 'One-time'].filter(Boolean).join('  ·  ');
        barAdd.textContent = 'Add';
      };

      barAdd.addEventListener('click', function () { addCurrent(); });

      /* Show the bar only while the real button is off screen. */
      if ('IntersectionObserver' in window) {
        buybar.hidden = false;
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var past = e.boundingClientRect.top < 0 && !e.isIntersecting;
            buybar.classList.toggle('is-visible', past);
          });
        }, { threshold: 0 }).observe(addBtn);
      }

      el.addEventListener('click', syncBar);
      var origRenderAll = renderAll;
      renderAll = function () { origRenderAll(); syncBar(); };
      syncBar();
    }

    /* Swipe / arrows on the large image, so the gallery is not thumbs-only. */
    var stageEl = el.querySelector('[data-stage]');
    var step = function (d) {
      var n = slides().length;
      state.slide = (state.slide + d + n) % n;
      renderStage(); renderThumbs(); syncStageChrome();
    };
    function syncStageChrome() {
      var c = el.querySelector('[data-stage-count]');
      if (c) c.textContent = (state.slide + 1) + ' / ' + slides().length;
    }
    attachSwipe(stageEl, function () { step(1); }, function () { step(-1); });
    var pv = el.querySelector('[data-stage-prev]'), nx = el.querySelector('[data-stage-next]');
    if (pv) pv.addEventListener('click', function () { step(-1); });
    if (nx) nx.addEventListener('click', function () { step(1); });

    renderAll();
    syncStageChrome();
  });

  /* ------------------------------------------------- standalone gallery --- */

  /* Product page: thumbs + swipe over a plain list of images. */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var shot = g.querySelector('[data-shot]');
    var thumbs = [].slice.call(g.querySelectorAll('[data-thumb]'));
    var count = g.querySelector('[data-stage-count]');
    if (!shot || !thumbs.length) return;
    var i = 0;

    function show(n) {
      i = (n + thumbs.length) % thumbs.length;
      shot.src = thumbs[i].dataset.thumb;
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', String(k === i)); });
      if (count) count.textContent = (i + 1) + ' / ' + thumbs.length;
      thumbs[i].scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }

    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    var pv = g.querySelector('[data-stage-prev]'), nx = g.querySelector('[data-stage-next]');
    if (pv) pv.addEventListener('click', function () { show(i - 1); });
    if (nx) nx.addEventListener('click', function () { show(i + 1); });
    attachSwipe(g.querySelector('[data-stage]'), function () { show(i + 1); }, function () { show(i - 1); });
    show(0);
  });

  /* ------------------------------------------------------------------ duo */

  document.querySelectorAll('[data-duo]').forEach(function (el) {
    var shot = el.querySelector('[data-duo-shot]');
    var priceEl = el.querySelector('[data-duo-price]');
    var addBtn = el.querySelector('[data-duo-add]');
    var pairs = el.querySelectorAll('[data-duo-pair]');

    function activePair() {
      for (var i = 0; i < pairs.length; i++) {
        if (pairs[i].getAttribute('aria-pressed') === 'true') return pairs[i];
      }
      return pairs[0];
    }

    var subWrap = el.querySelector('[data-duo-sub-wrap]');
    var subBox = el.querySelector('[data-duo-sub]');

    /* A pairing can be subscribed to only when both products carry a plan. */
    function canSubscribe(btn) {
      return !!(btn && btn.dataset.planA && btn.dataset.planB && Number(btn.dataset.subPct) > 0);
    }

    function subscribing(btn) {
      return canSubscribe(btn) && subBox && subBox.checked;
    }

    function syncPair(btn) {
      if (!btn) return;
      if (shot && btn.dataset.image) {
        /* One composed photograph per pairing, so a single swap is enough. */
        shot.src = btn.dataset.image;
        shot.alt = btn.dataset.alt || shot.alt;
      }

      if (subWrap) {
        subWrap.hidden = !canSubscribe(btn);
        var pctEl = subWrap.querySelector('[data-duo-sub-pct]');
        if (pctEl) pctEl.textContent = canSubscribe(btn) ? Number(btn.dataset.subPct) + '%' : '';
      }

      if (!priceEl) return;
      var nowEl = priceEl.querySelector('[data-duo-now]');
      var wasEl = priceEl.querySelector('[data-duo-was]');
      var saveEl = priceEl.querySelector('[data-duo-save]');

      /* A fixed price from the section settings still wins if one is set. */
      if (priceEl.dataset.priceOverride) {
        priceEl.hidden = false;
        if (nowEl) nowEl.textContent = priceEl.dataset.priceOverride;
        if (wasEl) {
          wasEl.textContent = priceEl.dataset.priceCompare || '';
          wasEl.hidden = !priceEl.dataset.priceCompare;
        }
        if (saveEl) saveEl.hidden = true;
        return;
      }

      var list = Number(btn.dataset.cents);
      if (!list) { priceEl.hidden = true; return; }

      /* Same order Shopify uses: plan price first, then the two-pack
         discount on top of it. */
      /* Shopify rounds each pack's line separately, so the pair is priced
         per pack and doubled; rounding the pair as one sum is a cent out
         ($50.49 shown against $50.50 charged). */
      var pack = list / 2;
      if (subscribing(btn)) pack = Math.round(pack * (1 - Number(btn.dataset.subPct) / 100));
      pack = Math.round(pack * (1 - (Number(priceEl.dataset.discount) || 0) / 100));
      var now = pack * 2;

      priceEl.hidden = false;
      if (nowEl) nowEl.textContent = money(now);
      if (wasEl) {
        wasEl.textContent = money(list);
        wasEl.hidden = now >= list;
      }
      if (saveEl) {
        saveEl.hidden = now >= list;
        saveEl.textContent = 'Save ' + money(list - now);
      }
    }

    pairs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        pairs.forEach(function (x) {
          x.setAttribute('aria-pressed', String(x === btn));
        });
        syncPair(btn);
      });
    });

    if (subBox) subBox.addEventListener('change', function () { syncPair(activePair()); });

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var btn = activePair();
        if (!btn) return;
        /* The Duo is not its own SKU — it adds the two chosen products as
           separate line items in one request, each on its own plan when
           subscribing. */
        var sub = subscribing(btn);
        var items = [
          { id: Number(btn.dataset.variantA), quantity: 1 },
          { id: Number(btn.dataset.variantB), quantity: 1 }
        ].filter(function (i) { return i.id; });
        if (items.length < 2) {
          toast('Duo is not connected to products yet.');
          return;
        }
        if (sub) {
          items[0].selling_plan = Number(btn.dataset.planA);
          items[1].selling_plan = Number(btn.dataset.planB);
        }
        postCart({
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        }, 'Duo · ' + (btn.dataset.label || ''));
      });
    }

    syncPair(activePair());
  });

  /* --------------------------------------- Kaching pane forms (home) ---- */

  /* Kaching normally cancels the submit and adds the bundle itself. If it
     does not (no deal, or the app is off), add over AJAX with whatever
     fields are in the form rather than letting the page navigate away. */
  document.addEventListener('submit', function (event) {
    var form = event.target.closest && event.target.closest('[data-kform]');
    if (!form || event.defaultPrevented) return;
    event.preventDefault();
    postCart({
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    }, form.dataset.label || 'Item');
  });

  /* ------------------------------------------- product form add-to-cart */

  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var select = form.querySelector('[name="id"]');
      var label = form.dataset.label || 'Item';
      addToCart(select && select.value, '', label);
    });
  });
})();
